import React from 'react';
import PropTypes from 'prop-types';
import isNaN from 'lodash/isNaN';
import { ValidatedTextInput } from '@els/els-react--text-input';
import usePostActionFocus from '@Hooks/usePostActionFocus';

function GoToPage({ chunksCount, onClick }) {
  const [inputValue, setInputValue] = React.useState('');
  const CONTROL_ID = 'go-to-page';
  const inputRef = React.useRef(null);

  // TextInput supports an `inputRef` prop; provide that ref to the hook as the preferred focus target
  const { ref: wrapperRef, markActive } = usePostActionFocus({
    id: CONTROL_ID,
    dependentKeys: [inputValue],
    forwardedRef: inputRef,
    avoidIfActiveSelector: '.results-per-dropdown',
  });

  const validateInputValue = (valueAsInteger) => {
    if (isNaN(valueAsInteger)) {
      return false;
    }

    if (valueAsInteger > chunksCount) {
      return false;
    }

    return valueAsInteger !== 0;
  };

  const goToHandler = () => {
    const valueAsInteger = parseInt(inputValue, 10);

    if (!validateInputValue(valueAsInteger)) return;

    // Mark GoToPage as the active control so it regains focus after submit
    markActive();
    onClick(valueAsInteger);
    setInputValue('');
  };

  const onChange = (e) => {
    const { value } = e.target;
    const valueAsInteger = parseInt(value, 10);
    const newInputValue = isNaN(valueAsInteger) ? '' : valueAsInteger;
    setInputValue(newInputValue);
  };

  const onKeyPress = (e) => {
    if (e.key === 'Enter') {
      goToHandler();
    }
  };

  const isValidInputValue = validateInputValue(parseInt(inputValue, 10));

  return (
    <div ref={wrapperRef}>
      <ValidatedTextInput
        inputRef={inputRef}
        iconRight={{
          id: 'goToPage',
          sprite: 'ChevronRight',
          children: 'Go To Page',
          color: isValidInputValue ? 'secondary' : undefined,
          a11y: {
            name: 'Go to page',
          },
        }}
        label="Go to page"
        validator="numeric"
        data-e2e="go-to-page-input"
        shouldHideLabel
        value={inputValue}
        className="bar-chart-checkboxes-dialog__go-to-page"
        onKeyPress={onKeyPress}
        iconRightCallback={isValidInputValue ? goToHandler : undefined}
        onChange={onChange}
      />
    </div>
  );
};

GoToPage.propTypes = {
  chunksCount: PropTypes.number,
  onClick: PropTypes.func.isRequired,
};

export default GoToPage;
